<div class="row" *ngIf="order.reference">
  <div class="col-md-8 col-sm-12">
    <form novalidate #serviceRemarkForm="ngForm">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <app-card [title]="('admin.service_request.detail'|translate) + order.reference">
              <!--one col form input type-->
              <div class="form-group ">
                <div class="container">
                  <div class="card-align">
                    <div class="row">

                      <div class="col-sm-6">
                        <label for="subject">{{"doctrine.service_request.subject" | translate}} *</label>
                        <input type="text" id="subject" name="subject" #subject="ngModel"
                               [(ngModel)]="serviceRemark.subject"
                               class="form-control" required>
                        <div class="messages text-danger"
                             *ngIf="subject.invalid && subject.dirty && subject.errors.required">
                          {{'errors.required'|translate}}
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <label for="phone">{{"doctrine.service_request.phone" | translate}} </label>
                        <input type="text" id="phone" name="phone" [(ngModel)]="serviceRemark.phone"
                               class="form-control">
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group ">
                <div class="container">
                  <div class="card-align">
                    <div class="row">
                      <div class="col-md-12 mb50">
                        <label for="message">{{"doctrine.service_request.message" | translate}} *</label>
                        <textarea name="message" id="message" cols="30" rows="10" class="form-control"
                                  #message="ngModel" [(ngModel)]="serviceRemark.message" required></textarea>
                        <div class="messages text-danger"
                             *ngIf="message.invalid && message.dirty && message.errors.required">
                          {{'errors.required'|translate}}
                        </div>
                      </div>
                      <div class="col-md-12">
                        <!-- File upload card end -->
                        <div class="row">
                          <div class="col-md-12">
                            <app-file-uploader
                              [(ngModel)]="serviceRemark.files"
                              [ngModelOptions]="{standalone: true}"
                              label="{{'admin.service_request.files' | translate}}"
                              description="{{'validators.file' | translate}}"
                              accept=".png,.gif,.jpg,.xls,.xlsx,.doc,.docx,.pdf,.mp4,.webm,.mov,.wmv,.avi,.mkv"
                              scope="dealer-system"
                              bupload="serviceRequest.files"
                              fieldName="files"
                              [queueLimit]="5"
                            ></app-file-uploader>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-block pull-right">
                <button (click)="submitItem(false)" class="btn btn-link"
                        type="button">{{'global.cancel'|translate}}</button>
                <button [disabled]="serviceRemarkForm.invalid || disableBtn || isUploading" (click)="submitItem(true)"
                        class="btn btn-primary ripple light"
                        type="button">
                  <span *ngIf="disableBtn" class="spinner-border spinner-border-sm" role=" status"
                        aria-hidden="true"></span>
                  {{ (disableBtn ? 'global.loading' : 'doctrine.service_request.send_request') | translate}}</button>
              </div>
            </app-card>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="col-md-4 col-sm-12">
    <div class="col-md-12">
      <app-card id="order_details" [title]="'admin.service_request.order.title'|translate">
        <div class="row">
          <div class="col-md-4">
            <p>{{'doctrine.attributes.order'|translate}}:</p>
            <p>{{'doctrine.order.reference'|translate}}:</p>
            <p>{{'doctrine.user.company'|translate}}:</p>
            <p>{{'doctrine.order.by'|translate}}:</p>
            <p>{{'doctrine.user.email'|translate}}:</p>
          </div>
          <div class="col-md-8">
            <p>{{order.orderNo}}</p>
            <p>{{order.reference}}</p>
            <p>{{order.user.companyName ? order.user.companyName : ''}}</p>
            <ng-container *ngIf="order.serviceContact?.email; else mainContact">
              <p>{{order.serviceContact.fullName ?? ''}}</p>
              <p>{{order.serviceContact.email ?? ''}}</p>
            </ng-container>
            <ng-template #mainContact>
              <p>{{order.user.firstName}} {{order.user.lastName}}</p>
              <p>{{order.user.email}}</p>
            </ng-template>
          </div>
        </div>
      </app-card>
    </div>
    <div class="col-md-12">
      <app-card id="contact_details" [title]="'admin.service_request.contact.title'|translate">
        <div class="row">
          <div class="col-md-4">
            <p>{{'contact.address.title'| translate}}:</p>
          </div>
          <div class="col-md-8">
            <p>{{'contact.address.description.company_name'| translate}}</p>
            <p>{{'contact.address.description.street'| translate}}</p>
            <p>{{'contact.address.description.postal_code'| translate}}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <p>{{'contact.email.title'| translate}}:</p>
          </div>
          <div class="col-md-8">
            <p>{{'contact.email.description'| translate}}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <p>{{'contact.phone.title'| translate}}:</p>
          </div>
          <div class="col-md-8">
            <p>{{'contact.phone.description'| translate}}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <p>{{'contact.bank.title'| translate}}:</p>
          </div>
          <div class="col-md-8">
            <p>{{'contact.bank.description.IBAN'| translate}}</p>
            <p>{{'contact.bank.description.BIC/SWIFT'| translate}}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <p>{{'contact.legal.title'| translate}}:</p>
          </div>
          <div class="col-md-8">
            <p>{{'contact.legal.description.KvK'| translate}}</p>
            <p>{{'contact.legal.description.BTW'| translate}}</p>
          </div>
        </div>
      </app-card>
    </div>
  </div>
</div>

<app-modal-basic #sendRequestModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.send_service_request_title' | translate}}</h4>
    <button type="button" class="close basic-close" (click)="sendRequest()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.send_service_request_body' | translate}}</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-primary ripple light"
            (click)="sendRequest()">{{'global.ok'|translate}}</button>
  </div>
</app-modal-basic>



